<template lang="pug">
  .row-content.d-flex.align-center.bodyAggregatorPromotions
    v-col.dateMenuItem(cols="2")
      span {{ itemMenu.star_date }}
    v-col.nameMenuItem.text-truncate(cols="5")
      v-tooltip(right color="#fff" nudge-bottom="40" :open-delay="1000" content-class="tooltip-name" transition="slide-x-transition")
        template(v-slot:activator="{ on, attrs }")
          span.name.text-truncate(v-bind="attrs" v-on="on") {{ itemMenu.name }}
        .tooltip
          span {{ itemMenu.name }}
          br
          span {{ itemMenu.description }}
    v-col.priceMenuItem(cols="3")
      span {{ itemMenu.price | formatNumber(2,2)}} €
    v-col.numberCentersMenuItem.pl-0(cols="2")
      span.cursor-pointer(@click="$emit('click')") {{ itemMenu.n_centers }} #[translate Rest.]
</template>

<script>
export default {
  name: "promoItemMenu",
  props: {
    itemMenu: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.tooltip-name{
  color: #000;
  border: 1px solid #0000008c!important;
  max-width: 600px;
}
.bodyAggregatorPromotions{
  border-top:1px solid #D9DFE8;
  .dateMenuItem{
    color:#9B9B9B;
    font-size: 10px;
  }
  .nameMenuItem{
    font-size: 0.813rem;
    color:#000;
  }
  .priceMenuItem{
    font-size: 0.813rem;
    text-align: right;
    font-weight: 600;
    color:#000
  }
  .numberCentersMenuItem{
    font-size: 0.813rem;
  }
  .numberCentersMenuItem{
    text-align: right;
    color:var(--v-terciary-base);
  }
}
</style>
